var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1376,
    height: 480,
    viewBox: "0 0 1376 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1376,
    height: 480,
    rx: 16,
    fill: "#61A60E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1375.91 225.247L1375.91 16C1375.91 7.16346 1368.74 6.1084e-06 1359.91 6.00302e-06L856.502 0C873.593 58.523 904.853 112.547 947.851 155.583C1017.71 225.225 1110.27 263.78 1209.06 264L1210.26 264C1268.69 264 1325.1 250.597 1375.91 225.247Z",
    fill: "#7FB63C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.88396e-05 49L-6.99382e-07 464C-3.13124e-07 472.837 7.16342 480 16 480L530.263 480C524.837 443.296 512.471 407.558 493.367 374.405C453.373 304.939 388.44 255.102 310.68 234.038C284.849 227.046 258.216 223.55 231.851 223.55C189.007 223.55 146.431 232.693 106.972 250.441L106.972 249.186C100.113 181.064 69.5613 116.706 21.017 68.2138C14.2705 61.446 7.25705 55.0382 -1.88396e-05 49Z",
    fill: "#7FB63C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.cdfb3636d86ee9b98ea37547a04718a2.svg";
export { ForwardRef as ReactComponent };